function validateTextLength(text, maxLength, addEllipsis = true) {
    if (!text)
        return '';
    if (text.length <= maxLength) {
        return text;
    }
    const truncated = text.substring(0, maxLength);
    return addEllipsis ? `${truncated}...` : truncated;
}
function validateTitle(title) {
    return validateTextLength(title, 40, true);
}
function validateDescription(description) {
    return validateTextLength(description, 460, true);
}
function validateButtonLabel(label) {
    return validateTextLength(label, 20, true);
}

export { validateButtonLabel, validateDescription, validateTextLength, validateTitle };
